<ng-container *transloco="let t">
  @if(item.navCap){
  <div mat-subheader class="nav-caption truncate">
    {{ item.navCap | transloco }}
  </div>
  } @if(!item.navCap && !item.external && !item.twoLines) {
  <a mat-list-item (click)="onItemSelected(item)" [ngClass]="{
    'mat-toolbar mat-primary activeMenu': isMenuActive(item),
    expanded: expanded, activemenu: isChildActive(item),
    disabled: item.disabled,
    'submenu-item': depth > 0
  }" [style.--nav-depth]="depth" class="menu-list-item">
    <span class="iconify routeIcon" matListItemIcon [attr.data-icon]="item.iconName"></span>
    <span class="hide-menu truncate">{{ item.displayName | transloco }}</span>
    <div class="flex items-center gap-1">
      @if(item.children && item.children.length) {
      @if(item.chip) {
      <span>
        <span class="{{ item.chipClass }} px-2 py-1 item-chip font-medium rounded-full truncate">{{ item.chipContent
          }}</span>
      </span>
      }
      <span class="arrow-icon" fxFlex>
        <span fxFlex></span>
        <mat-icon [style.transform]="expanded ? 'rotate(180deg)' : 'rotate(0deg)'"
          style="transition: transform 225ms cubic-bezier(0.4, 0, 0.2, 1)">
          expand_more
        </mat-icon>
      </span>
      }
      <!-- @else {
      <button mat-icon-button [matMenuTriggerFor]="sideMenu" (click)="$event.stopPropagation()">
        <i class="iconify text-2xl opacity-80" data-icon="mdi:dots-vertical"></i>
      </button>
      } -->
    </div>
    @if(item.chip && !item.children ) {
    <span>
      <span class="{{ item.chipClass }} px-2 py-1 item-chip font-medium rounded-full truncate">{{ item.chipContent
        }}</span>
    </span>
    }
  </a>
  }

  <!-- external Link -->

  @if(!item.navCap && item.external) {
  <mat-list-item onClick="window.open('//google.com')" class="menu-list-item" target="_blank">
    <span class="iconify routeIcon" matListItemIcon [attr.data-icon]="item.iconName"></span>
    <span class="hide-menu truncate">{{ item.displayName | transloco }}</span>
  </mat-list-item>
  }

  <!-- children -->
  @if(expanded) { @for(child of item.children; track child) {
  <app-nav-item [item]="child" (click)="onSubItemSelected(child)" [depth]="depth + 1">
  </app-nav-item>
  } }


  <!-- <mat-menu #sideMenu>
    <button mat-menu-item (click)="openNewWindow(item);">
      <div class="flex items-center gap-4">
        <i class="iconify text-2xl opacity-80" data-icon="solar:add-square-outline"></i>
        <span>{{t('New')}}</span>
      </div>
    </button>
  </mat-menu> -->

</ng-container>
